import React from 'react';

import { Container, Row, Cell } from './styles';

interface SkeletonTableProps {
  /** Número de linhas de esqueleto. */
  rows?: number;
  /** Número de células por linha. */
  columns?: number;
}

/**
 * Esqueleto de tabela/lista para estados de carregamento do admin. Substitui
 * o spinner no meio do conteúdo por uma silhueta da própria tabela.
 */
const SkeletonTable: React.FC<SkeletonTableProps> = ({ rows = 5, columns = 4 }) => {
  return (
    <Container aria-hidden="true" role="status" aria-label="Carregando">
      {Array.from({ length: rows }).map((_, r) => (
        <Row key={r}>
          {Array.from({ length: columns }).map((__, c) => (
            <Cell key={c} />
          ))}
        </Row>
      ))}
    </Container>
  );
};

export default SkeletonTable;
